export default "__VITE_ASSET__85aed3c8__"